
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments-and-refunds",
      function () {
        return require("private-next-pages/payments-and-refunds.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments-and-refunds"])
      });
    }
  